import { render, staticRenderFns } from "./content-preview.vue?vue&type=template&id=b4ec7ac4&scoped=true&"
import script from "./content-preview.vue?vue&type=script&lang=js&"
export * from "./content-preview.vue?vue&type=script&lang=js&"
import style0 from "./content-preview.vue?vue&type=style&index=0&id=b4ec7ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ec7ac4",
  null
  
)

export default component.exports